import React from "react";
import SubscriptionsListing from "./SubscriptionsListing";
import { useParams } from "react-router-dom";

export default function Subscriptions(props) {
  let { status } = useParams();

  const type = status;
  const title = "Subscriptions";

  return <SubscriptionsListing type={type} title={title} />;
}
